import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UpdateWorkspaceVersion, VersionComparisonResponse, WorkspaceDocVersion } from '@workspaces/models/versions';
import { SKIP_ERROR_HANDLING } from '@workspaces/utils/workspace.interceptor';
import { filter, Observable } from 'rxjs';
import { DriftConfiguration } from 'src/app/models/configuration.interface';
import { ConfigurationService } from 'src/app/services/configuration.service';

@Injectable()
export class WorkspaceVersionService {
  private readonly workspaceUrl = '/workspace';
  private config!: DriftConfiguration;
  constructor(
    private readonly httpClient: HttpClient,
    private readonly configurationService: ConfigurationService
  ) {
    //No unsub required
    this.configurationService
      .configurationLoaded()
      .pipe(filter(loaded => loaded === true))
      .subscribe(() => {
        this.config = this.configurationService.getConfiguration();
      });
  }

  private get apiUrl() {
    return `${this.config.driftApi}${this.workspaceUrl}`;
  }

  public restoreVersion(workspaceId: string, versionId: string): Observable<void> {
    const path = `${this.apiUrl}/${workspaceId}/versions/restore`;
    return this.httpClient.post<void>(path, { version_id: versionId });
  }

  public updateVersion(workspaceId: string, versionId: string, updateData: UpdateWorkspaceVersion): Observable<void> {
    const path = `${this.apiUrl}/${workspaceId}/versions/${versionId}`;
    return this.httpClient.put<void>(path, updateData);
  }

  public getVersion(workspaceId: string): Observable<WorkspaceDocVersion[]> {
    const path = `${this.apiUrl}/${workspaceId}/versions`;
    return this.httpClient.get<WorkspaceDocVersion[]>(path);
  }

  public compareVersions(
    workspaceId: string,
    version1: string,
    version2: string
  ): Observable<VersionComparisonResponse> {
    const context = new HttpContext();
    context.set(SKIP_ERROR_HANDLING, true);
    const path = `${this.apiUrl}/${workspaceId}/versions/${version1}/compare/${version2}`;
    return this.httpClient.get<VersionComparisonResponse>(path, { context });
  }
}
